import {AxiosResponse} from "axios";
import {IConfiguration} from "Interfaces/IConfiguration";
import {AxiosConfig} from "./AxiosConfig/AxiosConfig";

const getConfiguration = (): Promise<IConfiguration> => {
    return new Promise<IConfiguration>((resolve, reject) => {
        return AxiosConfig.instance.get("/api/settings").then((response: AxiosResponse) => {
            return resolve(response.data);
        }).catch(error => {
            console.error(error)
            reject("Can't get client configuration");
        })
    })
}

export const ConfigurationApi = {
    getConfiguration,
}